var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaterbodiesScreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    fill: "#5C80BC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1272 12.4307C25.4618 12.0615 24.606 11.1554 23.8971 10.1465C23.4524 9.5152 22.4761 9.554 21.9936 10.1602C20.8925 11.5466 19.246 12.6551 16.6399 12.6551C14.0107 12.6551 12.359 11.2446 11.2568 9.91686C10.7953 9.36104 9.91438 9.36943 9.51062 9.96196C8.77441 11.0422 7.91865 12.0384 6.15259 12.4307M27.1272 22.918C25.4618 22.5488 24.606 21.6427 23.8971 20.6338C23.4524 20.0025 22.4761 20.0402 21.9936 20.6475C20.8925 22.0339 19.246 23.1424 16.6399 23.1424C14.0107 23.1424 12.359 21.7318 11.2568 20.4042C10.7953 19.8483 9.91438 19.8567 9.51062 20.4492C8.77546 21.5294 7.91865 22.5257 6.15259 22.918M27.1272 17.6743C25.4618 17.3052 24.606 16.3991 23.8971 15.3902C23.4524 14.7588 22.4761 14.7966 21.9936 15.4038C20.8925 16.7902 19.246 17.8987 16.6399 17.8987C14.0107 17.8987 12.359 16.4882 11.2568 15.1605C10.7953 14.6047 9.91438 14.6131 9.51062 15.2056C8.77546 16.2858 7.91865 17.2821 6.15259 17.6743",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterbodiesScreenIcon);
export default __webpack_public_path__ + "static/media/waterbodiesScreenIcon.1a9acb115ad315005737d1bc13b58486.svg";
export { ForwardRef as ReactComponent };